<template>
    <div class="operationLog">
        <div class="info-top">操作记录</div>
        <div class="info-down">
            <header>
                <el-date-picker
                    v-model="dateData"
                    type="daterange"
                    unlink-panels
                    size="small"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    style="width: 35%"
                    >
                </el-date-picker>
                <el-button type="primary" size="small">查询</el-button>
            </header>
            <div class="table-box">
                <el-table
                    :data="table.data"
                    height="100%"
                    highlight-current-row
                    >
                    <el-table-column
                        v-for="( i, key) in table.key"
                        :key="key"
                        :prop="i.name"
                        :label="i.displayName"
                        show-overflow-tooltip
                        >
                    </el-table-column>
                </el-table>
            </div>
            <div class="info-down-footer">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 200, 300, 400]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="400">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../utils/httpClient'
export default {
    components: {
        
    },
    name: 'operationLog',
    data () {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dateData: '',
            table: {
                data: [],
                key: []
            },
            currentPage: 2
        }
    },
    methods : {
        handleSizeChange(){

        },
        handleCurrentChange(){

        }
    },
    mounted () {
        this.table.data = [
            {
                "dn":null,
                "cn":"ADMINISTRATOR",
                "smartShortname":"普通管理员",
                "description":"普通管理员",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=administrator,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":"测试"
            },
            {
                "dn":null,
                "cn":"GROUPCONTAINERADMIN",
                "smartShortname":"容器管理员",
                "description":"容器管理员",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=groupcontaineradmin,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":null
            },
            {
                "dn":null,
                "cn":"ORGADMIN",
                "smartShortname":"组织(部门)管理员",
                "description":"组织(部门)管理员",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=orgadmin,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":null
            },
            {
                "dn":null,
                "cn":"SUPERADMINISTRATOR",
                "smartShortname":"超级管理员",
                "description":"超级管理员",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=superadministrator,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":"hhhh"
            },
            {
                "dn":null,
                "cn":"OTHERADMIN",
                "smartShortname":"定制管理员",
                "description":"定制管理员",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=otheradmin,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":null
            },
            {
                "dn":null,
                "cn":"JOBADMIN",
                "smartShortname":"岗位管理员",
                "description":"岗位管理员角色群组（系统设置群组，不可直接删除成员）",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=jobadmin,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":"cn=角色容器,ou=Groups,dc=bizenit,dc=com",
                "smartChangeRemark":"lll"
            },
            {
                "dn":null,
                "cn":"wdqdqw",
                "smartShortname":"dqw1",
                "description":"dqwd",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=wdqdqw,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":null,
                "smartChangeRemark":null
            },
            {
                "dn":null,
                "cn":"tertwrtre",
                "smartShortname":"13123",
                "description":"dqwd",
                "smartType":"0",
                "smartStatus":"已启用",
                "entryDN":"cn=tertwrtre,ou=groups,dc=bizenit,dc=com",
                "isMemberOf":null,
                "smartChangeRemark":"dwqd"
            }
        ];
        this.table.key = [
            {
                "name":"smartShortname",
                "displayName":"名称"
            },
            {
                "name":"description",
                "displayName":"描述"
            },
            {
                "name":"smartType",
                "displayName":"类型"
            },
            {
                "name":"cn",
                "displayName":"群组"
            },
            {
                "name":"smartStatus",
                "displayName":"状态"
            }
        ];
    }
}
</script>

<style lang="scss" scoped>
.operationLog{
    width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column;
    .info-top{
        height: 60px; width: 100%; margin-bottom: 16px; background: #ffffff; padding: 20px; line-height: 20px; font-size: 16px; border: 1px solid #e8e8e8;
    }
    .info-down{
        flex: 1; overflow: hidden; background: #ffffff; width: 100%; padding: 0 30px; border: 1px solid #e8e8e8;
        header{
            height: 11.58%; display: flex; align-items: center;
        }
        .table-box{
            height: 75.55%;
        }
        .info-down-footer{
            height: 12.87%; display: flex; align-items: center;
        }
    }
}
</style>
<style>
.info-down header .el-date-editor .el-range-separator{
    width: auto!important;
}
.info-down header .el-button{
    margin-left: 40px; width: 80px;
}
.info-down .el-pagination{
    width: 100%;
}
.info-down .el-pagination{
    display: flex; justify-content: flex-end; align-items: center; position: relative;
}
.info-down .el-pagination .el-pagination__total{
    position: absolute; left: 0;
}
.info-down .el-pagination .el-pagination__sizes{
    position: absolute; left: 68px;
}
</style>




// WEBPACK FOOTER //
// src/components/operationLog.vue